import styled from 'styled-components';

import { Box } from '@ovpn-ui/core';
import { colors, media } from '@ovpn-ui/styles';

export const EntityInfoCardsWrapper = styled(Box).attrs({
    flex: true,
})`
    --gap: 24px;

    flex-direction: column;
    gap: var(--gap);

    .row {
        display: flex;
        gap: var(--gap);

        ${media.SM`
            flex-direction: column;
        `}
    }

    .ovpn-card {
        flex-grow: 1;
        gap: 8px;
        align-items: flex-start;
        max-width: initial;

        .card-title {
            display: flex;
            gap: 4px;
            align-items: center;

            .icon-tabler-help {
                color: ${colors.neutralTextSection};
            }
        }
    }
`;
